document.addEventListener("DOMContentLoaded", function () {
    toggle();
    window.onresize = function() {
        toggle();
    }
    function toggle() {
        if (window.innerWidth < 993) {
            let Sticky = require('sticky-js');
            let sticky = new Sticky('.header', {});
        }
    }
});
